<div class="page-header">
    <h2 id="generalLiabilityHeader">General Liability Information</h2>
</div>
<div [formGroup]="generalLiabilityForm">
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="lossType">Primary cause of the incident or damage</label>
            <select class="form-control nw-input--medium" name="lossType" id="lossType" aria-required="true" aria-describedby="lossType" [formControl]="lossType"
                (ngModelChange)="resetDependentLossTypeSelectLists()" [ngClass]="{'has-error':(lossType.touched && lossType.invalid)}">
                <option value="" selected>Select</option>
                <option value="Bodily Injury">Bodily Injury</option>
                <option value="Property Damage">Property Damage</option>
                <option value="Other Liability Type">Other Liability Type</option>
            </select>
            <div *ngIf="lossType.touched && lossType.invalid" class="alert alert-danger nw-field-error" id="lossTypeErrorId">
                <span id="lossTypeRequiredErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div *ngIf="lossType.value === 'Property Damage'" class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="estimatedDamages">Estimated Damages</label>
            <select class="form-control nw-input--medium" name="estimatedDamages" id="estimatedDamages" aria-required="true" aria-describedby="estimatedDamages" [formControl]="estimatedDamages"
                [ngClass]="{'has-error':(estimatedDamages.touched && estimatedDamages.invalid)}">
                <option value="" selected>Select an estimated damages</option>
                <option value="Under $50,000">Under $50,000</option>
                <option value="Between $50,000-$250,000">Between $50,000-$250,000</option>
                <option value="Over $250,000">Over $250,000</option>
                <option value="Unsure">Unsure</option>
            </select>
            <div *ngIf="estimatedDamages.touched && estimatedDamages.invalid" class="alert alert-danger nw-field-error" id="estimatedDamagesErrorId">
                <span id="estimatedDamagesErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div *ngIf="lossType.value === 'Other Liability Type'" class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="liabilitySubtype">Liability subtype</label>
            <select class="form-control nw-input--medium" name="liabilitySubtype" id="liabilitySubtype" aria-required="true" aria-describedby="liabilitySubtype" [formControl]="liabilitySubtype"
                [ngClass]="{'has-error':(liabilitySubtype.touched && liabilitySubtype.invalid)}">
                <option value="" selected>Select a liability subtype</option>
                <option *ngFor="let liabilitySubtype of liabilitySubtypes">{{liabilitySubtype}}</option>
            </select>
            <div *ngIf="liabilitySubtype.touched && liabilitySubtype.invalid" class="alert alert-danger nw-field-error" id="liabilitySubtypeErrorId">
                <span id="liabilitySubtypeErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="claimantName">{{claimantNameLabel}}</label>
            <input type="text" class="form-control" id="claimantName" name="claimantName" aria-required="true" aria-describedby="claimantName" [formControl]="claimantName"
                [ngClass]="{'has-error':(claimantName.touched && claimantName.invalid)}">
            <div *ngIf="claimantName.invalid && claimantName.touched" class="alert alert-danger nw-field-error" id="claimantNameErrorId">
                <span *ngIf="claimantName.hasError('required')" id="claimantNameErrorMessage">Required</span>
                <span *ngIf="claimantName.hasError('pattern')" id="claimantNameErrorMessage">{{claimantNameLabel}} is invalid</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="claimantPhoneNumber">
                Phone number</label>
            <input type="text" class="form-control" id="claimantPhoneNumber" name="phoneNumber" aria-required="true" aria-describedby="claimantPhoneNumber" placeholder="555-555-5555"
                [formControl]="claimantPhoneNumber" [ngClass]="{'has-error':(claimantPhoneNumber.touched && claimantPhoneNumber.invalid)}">
            <div *ngIf="claimantPhoneNumber.invalid && claimantPhoneNumber.touched" class="alert alert-danger nw-field-error" id="claimantPhoneNumberId">
                <span *ngIf="claimantPhoneNumber.hasError('required')" id="claimantPhoneNumberErrorMessage">Required</span>
                <span *ngIf="claimantPhoneNumber.hasError('pattern')" id="claimantPhoneNumberErrorMessage">Phone number is invalid</span>
            </div>
        </div>
    </div>
</div>